<template>
    <div class="tofes-250-main">
        <div class="tofes-250-main-header">
            <p class="title">טפסי 250 - נפגעי עבודה</p>
        </div>
        <div class="tofes-250-main_btns">
            <!-- טופס 250 רוסמן מרקט -->
            <a href="https://forms.tofes101.co.il/c/68413b17e0ccf07dfc476ca6/run/" target="_blank" rel="noopener" class="btn">
                <p>טופס 250 רוסמן מרקט</p>
            </a>

            <!-- טופס 250 ביוטי פארם -->
            <a href="https://forms.tofes101.co.il/c/68413f9b7865135170fab2ba/run/" target="_blank" rel="noopener" class="btn">
                <p>טופס 250 ביוטי פארם</p>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    setup() {


        return {}
    }
}
</script>

<style scoped>
.tofes-250-main {
    width: 100%;
    height: 100%;
}

.tofes-250-main-header {
    width: 100%;
    height: 30px;
}

.tofes-250-main_btns {
    width: 100%;
    max-width: 500px;
    height: calc(100% - 30px);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.title {
    font-size: 25px;
    color: var(--warning);
    text-align: center;
}

/* אותו CSS בסיסי, מותאם לכך שה־<a> הוא כעת הכפתור */
.btn {
    width: 80%;
    height: 150px;
    background: var(--purple);
    margin-bottom: 20px;
    border-radius: 10px;
    display: flex;
    /* ממשיך ליישר טקסט באמצע */
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
    /* מסיר קו תחתון של קישורים */
}

.btn p {
    font-size: 30px;
    color: #fff;
    margin: 0;
}

.btn:active {
    transform: scale(0.98);
}
</style>